import script from "./SkillsEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsEditorView.vue?vue&type=script&setup=true&lang=js"

import "./SkillsEditorView.vue?vue&type=style&index=0&id=a73da8a6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a73da8a6"]])

export default __exports__